// extracted by mini-css-extract-plugin
export var buttons = "countdownHero-module--buttons--a6b26";
export var cardContent = "countdownHero-module--cardContent--2634b";
export var countdown = "countdownHero-module--countdown--acd00";
export var countdownCard = "countdownHero-module--countdownCard--91094";
export var countdownFadeIn = "countdownHero-module--countdownFadeIn--c4488";
export var countdownGrid = "countdownHero-module--countdownGrid--4e735";
export var countdownHero = "countdownHero-module--countdownHero--fe3ab";
export var countdownText = "countdownHero-module--countdownText--36edd";
export var eyebrow = "countdownHero-module--eyebrow--8a02d";
export var header = "countdownHero-module--header--ec2a7";
export var headline = "countdownHero-module--headline--6e16b";
export var number = "countdownHero-module--number--ec827";
export var scrollAnimation = "countdownHero-module--scrollAnimation--b3fa8";
export var scrollDigit = "countdownHero-module--scrollDigit--bd2dc";
export var timeIncrement = "countdownHero-module--timeIncrement--3a226";
export var unitScrollAnimationFadeIn = "countdownHero-module--unitScrollAnimationFadeIn--65288";
export var unitScrollAnimationFadeOut = "countdownHero-module--unitScrollAnimationFadeOut--e68ee";
export var upperHeadline = "countdownHero-module--upperHeadline--03956";
export var upperSubtext = "countdownHero-module--upperSubtext--a9b9f";